export enum LogicFlowMessageSeverityEnum {

    INFO,
    WARNING,
    ERROR,
    DECISION_REQUIRED,
    TRACE,
    DEBUG,
}
